/**
 * «Pasa el limite de credito. ¿Vender igual?»
 *
 * El limite de credito avisa, no bloquea: la ficha del cliente lo dice asi. La
 * base rechaza la venta y la pantalla pregunta; si quien vende confirma, se
 * reintenta el mismo pedido con `forzar`. Antes el rechazo era un toast rojo
 * sin ningun boton, y la unica salida era sacarle el limite al cliente.
 */
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

import { textoCreditoExcedido, type CreditoExcedido } from "./limite-credito";

export function DialogLimiteCredito({
  credito,
  cliente,
  guardando,
  onCancelar,
  onVenderIgual,
}: {
  /** `null` cierra el dialogo. */
  credito: CreditoExcedido | null;
  cliente: string | null;
  guardando: boolean;
  onCancelar: () => void;
  onVenderIgual: () => void;
}): JSX.Element {
  return (
    <Dialog open={credito !== null} onOpenChange={(v) => !v && onCancelar()}>
      <DialogContent tamano="sm">
        <DialogHeader>
          <DialogTitle>Pasa el límite de crédito</DialogTitle>
          <DialogDescription>
            {credito ? textoCreditoExcedido(credito, cliente) : null} ¿Vender igual?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" variant="ghost" onClick={onCancelar}>
            Cancelar
          </Button>
          <Button type="button" cargando={guardando} onClick={onVenderIgual}>
            Vender igual
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
